import React from 'react';

const Home = () => {
    return (
        <div className="d-flex justify-content-center align-items-center vh-100">
            <div className="text-center">
                <img src="assets/images/logo.svg" height="150" alt="connect-logo" />
                <footer id="footer" className="container">
                    <h6 className="text-center">Copyright &copy; 2025 Imisepela. All rights reserved.</h6>
                </footer>
            </div>
        </div>
    );
};

export default Home;
